import * as React from 'react';

import classNames from 'classnames';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {PlayButtonIcon} from 'shells/icon/svg/play-button-icon';
import {Body} from 'shells/typography/body';

import {analyticsClient} from '../../../analytics-client';

import styles from './navbar-demo-button.module.css';

type Props = {
    onClick: () => void;
};

export function NavbarDemoButton(props: Props) {
    function handleClick() {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_NUTSHELL_NINETY_SECONDS_VIDEO_CLICKED);
        props.onClick();
    }

    return (
        <button
            type='button'
            className={classNames('nut-navbar--button', styles.button)}
            aria-label='Nutshell in 90 seconds'
            onClick={handleClick}
        >
            <span className={styles['play-icon']}>
                <PlayButtonIcon wrapWithDiv={false} size={16} color={colors.orange} />
            </span>
            <Body size='small' color='white'>
                Nutshell in 90 seconds
            </Body>
        </button>
    );
}
